import React, { useEffect, useState } from "react";
import { Dispatch } from "redux";
import { useLocation } from "react-router-dom";
import { connect } from "react-redux";
// import { getSVG } from "../../utils/getSvg";
import { GetScreenSize } from "../../utils/screenSize";
import { Drawer, Box, Dialog, Slide, useTheme } from "@mui/material";
import Scrollbar from "./Scrollbar";
import NavSection from "./NavSection";
import layoutActions from "../../redux/actions/layout.actions";
import { Rule, Business, Dashboard, Close, Dvr, Announcement, Settings } from "@mui/icons-material";

import Logo from "../../assets/images/valital-logo-name.png";
// const Transition = React.forwardRef(function Transition(props, ref) {
//   return <Slide direction="right" ref={ref} {...props} />;
// });

interface Props {
  sideNavState: boolean;
  sideNavChange: (value: boolean) => void;
}
const SideBar: React.FC<Props> = ({ sideNavChange, sideNavState }) => {
  const screenSize = GetScreenSize();
  const location = useLocation();
  const user = JSON.parse(
    localStorage.getItem("user") ??
      "{firstName:'', lastName: '', timezone:'', email: '', userType: ''}"
  );
  const navigations = [];
  const userType = user.adminType;

  if (userType === "admin") {
    navigations.push({
      name: "Dashboard",
      description: "Dashboard and Analytics page",
      sub: [
        {
          name: "Dashboard",
          type: "link",
          path: "/dashboards",
          icon: <Dashboard />,
          priority: "high",
        }       
      ],
    });
  }
  
  navigations.push( {
    name: 'Validations',
    description: "List of validations",
    sub: [
      {
        icon: <Rule />,
        name: 'Validations',
        priority: "high",
        sub:[{
          name: 'UPF',
          type: "link",
          path: `/validations`,
          priority: "high",
        },
        {
          name: 'API',
          type: "link",
          path: `/api-validations`,
          priority: "high",
        },
        {
          name: 'Live Updates',
          type: "link",
          path: `/live-update-validations`,
          priority: "high",
        }]
      },
    ],
  });

  /*{
      name: 'Roles',
      description: "Roles page",
      sub: [
        {
          name: 'Roles',
          type: "link",
          path: "/roles",
          icon: <Dvr />,
          priority: "high",
        },
      ],
    },*/

  if (userType === "admin") {
    navigations.push(
      {
        name: "Companies",
        description: "Companies page",
        sub: [
          {
            name: "Companies",
            type: "link",
            path: "/companies",
            icon: <Business />,
            priority: "high",
          },
        ],
      },
      {
        name: "Company Settings",
        description: "Company Settings and Management",
        sub: [
          {
            icon: <Settings />,
            name: "Settings",
            priority: "high",
            sub: [
              {
                name: "Users",
                type: "link",
                path: "/adminUsers",
                priority: "high",
              },
              {
                name: "UPF Announcements",
                type: "link",
                path: "/upf-announcements",
                priority: "high",
              },
            ],
          },
        ],
      }
    );
  }

  const theme = useTheme();
  const drawerWidth = 220;

  const content = (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          margin: "0.5rem 0 0 1rem",
        }}
      >
        <img
          src={Logo}
          width={screenSize.dynamicWidth < 666 ? "90%" : "100%"}
        />
        {screenSize.dynamicWidth < 666 ? (
          <Box
            sx={{ width: "100%", display: "flex", justifyContent: "flex-end" }}
            onClick={() => sideNavChange(false)}
          >
            <Close />
          </Box>
        ) : null}
      </Box>
      <Scrollbar options={{ suppressScrollX: true }}>
        <Box sx={{ padding: 2 }}>
          <Box sx={{ marginTop: 2 }}>
            {navigations.map((section) => (
              <NavSection
                key={section.name}
                pathname={location.pathname}
                {...section}
              />
            ))}
          </Box>
        </Box>
      </Scrollbar>
    </Box>
  );

  return (
    <Drawer
      //onMouseLeave={() => sideNavChange(false)}
      anchor="left"
      open={sideNavState}
      PaperProps={{
        sx: {
          backgroundColor: "background.paper",
          height: screenSize.dynamicWidth > 666 ? "95%" : "100%",
          borderRadius: screenSize.dynamicWidth > 666 ? "10px" : "0px",
          top: screenSize.dynamicWidth > 666 ? "17px" : 0,
          marginLeft: screenSize.dynamicWidth > 666 ? "0.6rem" : 0,
          width: screenSize.dynamicWidth > 666 ? drawerWidth : "100%",
          transform: `${
            sideNavState === true
              ? "none !important "
              : `translateX(${drawerWidth}) !Important`
          }`,
          transition:
            "transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms !Important",
        },
      }}
      variant="persistent"
    >
      {content}
    </Drawer>
  );
};

const mapStateToProps = (state: any) => ({
  sideNavState: state.layout.sideNavOpen,
});

const mapDispatchToProps = (dispatch: Dispatch<any>) => ({
  sideNavChange: (state: boolean) =>
    dispatch(layoutActions.updateSideNav(state)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SideBar);
